import React, { JSX } from 'react';
import { Box, Container } from '@chakra-ui/react';
import Breadcrumb from 'components/breadcrumb';
import { ROUTES } from 'services/shared/routerService';
import SEO from 'components/seo';
import DownloadHeroSection from 'components/downloadHeroSection';
import MobileAppUspSection from 'components/mobileAppUspSection';
import ScrollReveal from 'components/ScrollReveal';

interface PropsInterface {
	children?: React.ReactNode;
}

function Download(props: PropsInterface): JSX.Element {
	return (
		<Box as="section">
			<SEO
				title="Download Mobile App | AI Image & Video Production - Imagemotion"
				description="#1 AI Image & Video Production Platform. Download the Imagemotion app and create stunning content anytime, anywhere. From Your Pocket."
			/>

			<DownloadHeroSection />

			<Container maxW="6xl" pt={8}>
				<ScrollReveal direction="none">
					<Breadcrumb
						navigation={[
							{ label: 'Home', href: ROUTES.HOME },
							{ label: 'Download', href: ROUTES.DOWNLOAD, current: true },
						]}
					/>
				</ScrollReveal>
			</Container>

			<MobileAppUspSection />

			<Container maxW="6xl"></Container>
		</Box>
	);
}

export default Download;
